"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeAdAnalyticsVideoIndexKeywordSection = void 0;
const AdAnalyticsVideo_1 = require("../entity/AdAnalyticsVideo");
const timeObject_1 = require("./timeObject");
const createSomeAdAnalyticsVideoIndexKeywordSection = ({ start = timeObject_1.createSomeTimeObject({ hours: 0, minutes: 0, seconds: 10 }), end = timeObject_1.createSomeTimeObject({ hours: 0, minutes: 0, seconds: 15 }), } = {}) => new AdAnalyticsVideo_1.AdAnalyticsVideoIndexKeywordSection({
    start,
    end,
});
exports.createSomeAdAnalyticsVideoIndexKeywordSection = createSomeAdAnalyticsVideoIndexKeywordSection;
